<template>
  <div>
    <div style="margin: 1%" v-if="userInfo">
      <b-row>
        <b-col md="6" xl="6" cols="6">
          <b-form-group label-align="right" :label="$t('Bank account')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
            <b-form-input type="text" v-model="userInfo.bank_account"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Comments')" label-cols="4" label-cols-xl="4" label-cols-md="4"  >
            <b-form-textarea type="text" rows="2" v-model="userInfo.comments"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Personal manager')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
            <b-form-input type="text" v-model="userInfo.personal_manager"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Connection date')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
            <flat-picker
            @onDateChanged="(unixDate) => {userInfo.connect_date = unixDate}"
            @ready="(dp) => {dp.setDate($root.getMomentWithTZDelta(userInfo.connect_date ? userInfo.connect_date : new Date()/1000 ).toDate())}"
            />
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Binded currency ID')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
            <b-select v-model="userInfo.binded_currency_id" :options="currenciesOpts"/>
          </b-form-group>
        </b-col>
        <b-col md="6" xl="6" cols="6">
          <b-form-group label-align="right" :label="$t('Passport')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" v-model="userInfo.passport"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('ITIN')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
            <b-form-input type="text" v-model="userInfo.tax_number"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Reg code')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
            <b-form-input type="text" v-model="userInfo.kpp_number"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Bank')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-input-group>
              <b-form-input type="text" v-model="userInfo.bank_name" disabled :placeholder="$t('Tap to select')"/>
              <div style="position:absolute; left:0; right:0; top:0; bottom:0;" @click="showFormBank"/>
              <b-input-group-append>
                <b-button @click.stop="clear" variant="secondary" size="sm">{{ $t('Clear') }}</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Birthday')" label-cols="4" label-cols-xl="4" label-cols-md="4" >
            <md-button
            style="margin-top:0rem"
            v-if="userInfo.birthday == 0"
            class="md-raised"
            @click="userInfo.birthday = defaultBirthDay01012000">{{$t('Set value')}}</md-button>
            <div v-else>
              <flat-picker
              :enableTime="false"
              @onDateChanged="(unixDate) => {userInfo.birthday = unixDate}"
              @ready="(dp) => {dp.setDate($root.getMomentWithTZDelta(userInfo.birthday ? userInfo.birthday : new Date()/1000 ).toDate())}"
              />
          </div>
          </b-form-group>
        </b-col>
      </b-row>
    </div>

    <b-modal ref="bankUser" size="xl"  hide-footer :title="$t('Bank')">
      <FormBank @selectedBank="selectedBank" @hideFormBank="hideFormBank"></FormBank>
    </b-modal>
  </div>
</template>

<script>
import FormBank from '@/pages/users/usersAndGroups/detail/additional/formBank'
export default {
  components: {
    FormBank
  },
  props: {
    userInfo: null
  },
  data () {
    return {
      defaultBirthDay01012000: 946684800
    }
  },
  methods: {
    clear () {
      this.userBank = ''
      this.userInfo.bank_name = 'N/A'
      this.userInfo.bank_id = 0
    },
    selectedBank (bank) {
      this.userInfo.bank_id = bank.bank_id
      this.userInfo.bank_name = bank.name
    },
    showFormBank () {
      this.$refs.bankUser.show()
    },
    hideFormBank () {
      this.$refs.bankUser.hide()
    }
  },
  computed: {
    currenciesOpts () {
      let opts = []
      for (let el of this.$store.getters['ReferenceBooks/CURRENCIES']) {
        opts.push({text: el.currency_brief_name, value: el.currency_id})
      }
      return opts
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/personal/main.vue